/**
 * Layout Component
 * ----------------
 * This functional layout component provides the main application layout (after login),
 * including the left menubar, top navbar, and footer.
 *
 * Developer: Aashish Singh
 * Created Date: 29-March-2023
 *
 * @returns JSX.Element
 */

import React from "react";
import { useLocation } from "react-router-dom";
import { useStore } from "../../contexts/store-provider";
import CustomerLeftNavbar from "../navbar/customer-left-navbar";
import LeftNavBar from "../navbar/left-navbar";
import StoreLeftNavbar from "../navbar/store-left-navbar";
import "./layout.css";
import { getCurrentSidebarExpansionFromLocalStorage } from "../../helpers/localstorage-helper";

const Layout: React.FC<any> = (props) => {
  const { authStore } = useStore();
  const location = useLocation();

  // Routes where the navbar should be hidden
  const hideNavbarRoutes = [
    "/AccountActivation",
    "/huckster/AccountActivation",
    "/ResetPassword",
    "/huckster/ResetPassword",
    "/ForgotPassword",
    "/huckster/ForgotPassword",
    // "/LizeraStoreList",
    "/Customer/BookingManagement"
  ];

  // Routes that require special booking management navbar styling
  const fixingBookingNavbar = ["/Customer/BookingManagement"];

  // Determine if the navbar should be hidden for the current route
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname) || location.pathname.includes("/Customer/BookingManagement");

  // Get the current user type from the auth store
  const userType = authStore.getUserType;

  return (
    <div
      className="header-fixed sidebar-fixed sidebar-dark header-light"
      id="body"
    >
      <div className="wrapper">
        {/* Conditionally render the appropriate left navbar based on user type */}
        {!shouldHideNavbar &&
          (userType === "Customer" ? (
              <CustomerLeftNavbar
                email={authStore.getEmail}
                userType={userType}
              />
          ) : userType === "Store" ? (
            <StoreLeftNavbar email={authStore.getEmail} userType={userType} />
          ) : (
            <LeftNavBar email={authStore.getEmail} userType={userType} />
          ))}

        <main className="main-wrapper">
          <div
            id="moveContent"
            className={
              `content-wrapper container-fluid
                ${!shouldHideNavbar ? "" : "p-0"}
                ${getCurrentSidebarExpansionFromLocalStorage() ? "" : "ShiftLeftSide"}`
            }
          >
            {/* Render children components */}
            {props.children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
